<template>
  <figure>
    <v-chart :options="mapOption" class="cischart" auto-resize/>
  </figure>
</template>
<script>
//* *********************summary***************************//
// html:
// <cisMap :title="title"
// :subTitle="subTitle"
// :series-name="seriseName"
// :series-data="seriseList" min=0 max=100></cisMap>
//
// js data:
// {
// title: 'iphone销量分布图',
// subTitle: '测试数据',
// seriseName: 'iphoneXs', // ['iphone5','iphone6']
// seriseList: [{
//     name: '北京',
//     value: 2000
// },
// {
//     name: '天津',
//     value: Math.round(Math.random() * 1300)
// }]
// }
// or
// seriseList:[[{
//     name: '北京',
//     value: 2000
// },
// {
//     name: '天津',
//     value: Math.round(Math.random() * 1300)
// }], [{
//     name: '北京',
//     value: 2000
// },
// {
//     name: '天津',
//     value: Math.round(Math.random() * 1300)
// }]]
//* *********************summary***************************//
import 'echarts/lib/chart/map'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/visualMap'
import 'echarts/map/js/world'
export default {
  name: 'cisMap',
  props: ['title', 'subTitle', 'seriesData', 'seriesName', 'min', 'max'],
  data() {
    return {
      series: [],
      legends: []
    }
  },
  methods: {
    reloadSeries() {
      this.series = []
      if (this.seriesName && Array.isArray(this.seriesName) && this.seriesName.length > 1) {
        this.seriesName.forEach((name, index) => {
          this.series.push({
            name: name,
            type: 'map',
            mapType: 'china',
            showLegendSymbol: false,
            roam: false,
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              borderColor: '#fff'
            },
            data: this.seriesData[index]
          })
        })
      } else {
        this.series.push({
          name: this.seriesName,
          type: 'map',
          mapType: 'china',
          showLegendSymbol: false,
          roam: false,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            borderColor: '#fff'
          },
          data: this.seriesData
        })
      }
      this.legends = [...this.seriesName]
    }
  },
  mounted() {
    this.reloadSeries()
  },
  computed: {
    mapOption() {
      this.reloadSeries()
      return {
        title: {
          text: this.title,
          subtext: this.subTitle,
          left: 'left',
          textStyle: {
            fontSize: 16,
            color: '#333',
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: this.legends
        },
        visualMap: {
          min: this.min ? parseInt(this.min) : 0,
          max: this.max ? parseInt(this.max) : 1000,
          left: 'right',
          top: 'bottom',
          text: ['高', '低'], // 文本，默认为数值文本
          // calculable: true,
          inRange: {
            color: ['#d0e8ff', '#b6d6f4', '#78b5ee', '#3e89dd', '#1b67bd']
          }
        },
        toolbox: {
          show: false,
          orient: 'vertical',
          right: '10%',
          top: 'center',
          feature: {
            dataView: {
              show: true
            }
          }
        },
        series: this.series
      }
    }
  }
}
</script>
